<template>
    <div class="notice-wrap">
        <div class="notice-wrap1">
            <div class="notice">
                <div class="notice-title">
                    <div class="title-left">
                        <span class="notice-title-left">校内自行采购</span>
                        <div class="title-bottom">
                            <div class="title-divider"></div>
                            <span class="bottom-text">Notice</span>
                        </div>
                    </div>
                    <div class="notice-title-right" @click="goInform()">{{`更多>>`}}</div>
                </div>
                <div class="tags">
                    <div :class="['tag',{'tag-active':leftIndex == 0}]" @click="clickNoticeLeft(0)">
                        采购公告
                    </div>
                    <div :class="['tag',{'tag-active':leftIndex == 1}]" @click="clickNoticeLeft(1)">
                        结果公示
                    </div>
                    <div :class="['tag',{'tag-active':leftIndex == 2}]" @click="clickNoticeLeft(2)">
                        更正公告
                    </div>
                </div>
                <div class="notice-items" v-for="(item, index) in listB" :key="index" @click="jumps(item)">
                    <div class="notice-item">
                        <div class="notice-item-content">
                            <div class="notice-item-content1">
                                {{ item.title }}

                            </div>
                            <div class="notice-item-date">
                                {{ item.deployTime.substring(0, 10) }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="notice">
                <div class="notice-title">
                    <div class="title-left">
                        <span class="notice-title-left">竞价采购</span>
                        <div class="title-bottom">
                            <div class="title-divider"></div>
                            <span class="bottom-text">Notice</span>
                        </div>
                    </div>
                    <div class="notice-title-right" @click="goGuide()">{{`更多>>`}}</div>
                </div>
                <div class="tags">
                    <div :class="['tag',{'tag-active':rightIndex == 0}]" @click="clickNoticeRight(0)">
                        采购公告
                    </div>
                    <div :class="['tag',{'tag-active':rightIndex == 1}]" @click="clickNoticeRight(1)">
                        结果公示
                    </div>
                    <div :class="['tag',{'tag-active':rightIndex == 2}]" @click="clickNoticeRight(2)">
                        更正公告
                    </div>
                </div>
                <div class="notice-items" v-for="(item, index) in listA" :key="index" @click="jumps(item)">
                    <div class="notice-item">
                        <div class="notice-item-content">
                            <div class="notice-item-content1">
                                {{ item.title }}

                            </div>
                            <div class="notice-item-date">
                                {{ item.deployTime.substring(0, 10) }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            inf: "",
            gui: "",
            list: [],
            txt: "",
            listB: [],
            listA: [],
            pageNum: 1, //当前页码
            pageSize: 6, // 当前页大小
            leftIndex: 0,
            rightIndex: 0,
            dragMoved: false,
            xnzxcgggId: "",
            xnzxjgggId: "",
            xnzxgzggId: "",
            jjcgcgggId: "",
            jjcgjgggId: "",
            jjcggzggId: "",
        };
    },
    mounted() {
        GMS.vbus.$on("getId", (res) => {
            (this.xnzxcgggId = res.xnzxcgggId),
            (this.xnzxjgggId = res.xnzxjgggId),
            (this.xnzxgzggId = res.xnzxgzggId),
            (this.jjcgcgggId = res.jjcgcgggId),
            (this.jjcgjgggId = res.jjcgjgggId),
            (this.jjcggzggId = res.jjcggzggId),
            (this.inf = res.workerId),
                (this.gui = res.downloadCenterId),
                this.getInform();
            this.getGuide();
        });
    },
    methods: {
        startDrag(e) {
            const container = this.$refs.draggableContainer;
            this.isDragging = true;
            this.dragMoved = false;
            container.classList.add("dragging");
            this.startX = e.pageX;
            this.scrollLeft = container.scrollLeft;
        },
        onDrag(e) {
            if (!this.isDragging) return;
            const container = this.$refs.draggableContainer;
            const x = e.pageX;
            const walk = (x - this.startX) * 1.5;
            if (Math.abs(walk) > 5) {
                this.dragMoved = true; // 移动超过阈值，算拖动
            }
            container.scrollLeft = this.scrollLeft - walk;
        },
        stopDrag() {
            const container = this.$refs.draggableContainer;
            this.isDragging = false;
            container.classList.remove("dragging");
        },
        //获得通知公告列表
        getInform() {
            let guid = ""
            if(this.leftIndex === 0) {
                guid = this.xnzxcgggId; // 采购公告
            } else if (this.leftIndex === 1) {
                guid = this.xnzxjgggId; // 结果公示
            } else if (this.leftIndex === 2) {
                guid = this.xnzxgzggId; // 更正公告
            }
            let pram = {
                channels: JSON.stringify([guid]),
                filter: JSON.stringify({ deployed: 1 }),
                pageInfo: JSON.stringify({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }),
            };
            GMS.$http
                .post("/portal/cms/view/contents", pram, {})
                .then((res) => {
                    if (res.status == 200) {
                        this.listB = res.data.bean;
                        this.tital = res.data.total;
                    }
                })
                .catch((error) => {
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
        //跳转到通知公告详情页
        jumps(res) {
            GMS.$http
                .get(`/portal/cms/content?guid=` + res.guid, {
                
                })
                .then((value) => {
                    console.log('获取详情内容返回信息',value)
                    if (value.status == 200) {
                    const text = value.data.datas.data.text;
                    // Check if text contains "公告挂网地址" and has a URL
                    const urlMatch = text.match(/公告挂网地址：<a href="([^"]*)"[^>]*>([^<]*)<\/a>/i);
                    
                    if (urlMatch && urlMatch[1]) {
                        // Found a URL after "公告挂网地址", redirect to it
                         window.open(urlMatch[1], '_blank');
                    } else {
                        // No matching URL found, throw error which will trigger .catch()
                        throw new Error('No valid announcement URL found in content');
                    }
                    }
                }).catch((error) => {
                    this.jumpDetail(res);
                });
        },
        jumpDetail(res){
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            this.$router.push({
                                path: "/home/detail",
                                query: {
                                    title: res.title,
                                    name: "",
                                    guid: res.guid,
                                    total: res.title,
                                },
                            });
                        }
                    }
                });
        },
        //通知公告更多
        goInform() {
            let navlist = JSON.parse(sessionStorage.getItem("navList"));
            let item = navlist.find((qwe) => qwe.title === "校内自行采购公告");
            if (item.childList.length === 0) {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                        tagnum: item.childList[0].ordina,
                    },
                });
            }
        },
        // 获得办事指南列表页
        getGuide() {
            let guid = ""
            if(this.rightIndex === 0) {
                guid = this.jjcgcgggId; // 采购公告
            } else if (this.rightIndex === 1) {
                guid = this.jjcgjgggId; // 结果公示
            } else if (this.rightIndex === 2) {
                guid = this.jjcggzggId; // 更正公告
            }
            let pram = {
                channels: JSON.stringify([guid]),
                filter: JSON.stringify({ deployed: 1 }),
                pageInfo: JSON.stringify({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }),
            };
            GMS.$http
                .post("/portal/cms/view/contents", pram, {})
                .then((res) => {
                    if (res.status == 200) {
                        this.listA = res.data.bean;
                        this.tital = res.data.total;
                    }
                })
                .catch((error) => {
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
        // 获得下载列表
        getDownload(pram) {
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + pram, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            GMS.$http
                                .get(`/portal/cms/content/?guid=` + pram)
                                .then((res) => {
                                    if (res.status == 200) {
                                        this.txt = res.data.datas.data.text; //正文
                                        this.list = res.data.datas.attachements; //附件
                                        for (
                                            let i = 0;
                                            i < this.list.length;
                                            i++
                                        ) {
                                            this.download(this.list[i]);
                                        }
                                    }
                                })
                                .catch((error) => {
                                    this.$Message.error(
                                        "获取数据异常，请联系管理员"
                                    );
                                });
                        }
                    }
                });
        },
        clickNoticeLeft(index) {
            this.leftIndex = index;
            this.getInform(); // 切换标签时重新获取数据
        },
        clickNoticeRight(index) {
            this.rightIndex = index;
            this.getGuide(); // 切换标签时重新获取数据
        },
        //下载文件
        download({ guid, name = "download" }) {
            GMS.$http
                .get("/portal/cms/file?guid=" + guid, {
                    responseType: "blob",
                })
                .then((res) => {
                    let blob = new Blob([res.data], {
                        type: "multipart/form-data;charset=utf-8",
                    });
                    //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
                    let iconv = require("iconv-lite");
                    iconv.skipDecodeWarning = true; //忽略警告
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob); // 创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = name; // 下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); // 点击下载
                    document.body.removeChild(downloadElement); // 下载完成移除元素
                    window.URL.revokeObjectURL(href); // 释放掉blob对象
                });
        },
        //下载指南更多
        goGuide() {
            let navlist = JSON.parse(sessionStorage.getItem("navList"));
            let item = navlist.find((qwe) => qwe.title === "竞价采购");
            if (item.childList.length === 0) {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: item.id,
                        tagnum: item.childList[0].ordina,
                    },
                });
            }
        },
        jump(res) {
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            this.$router.push({
                                path: "/home/detail",
                                query: {
                                    title: "办事指南",
                                    name: "",
                                    guid: res.guid,
                                    total: res.title,
                                },
                            });
                        }
                    }
                });
        },
    },
};
</script>

<style lang="less" scoped>
.notice-title {
    height: 55px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
        display: flex;
        flex-direction: column;
        .notice-title-left {
            opacity: 0.89;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            font-size: 26px;
            color: #2947ac;
        }
        .title-bottom {
            display: flex;
            align-items: center;
            .title-divider {
                width: 28px;
                height: 1px;
                border: 2px solid #e8b138;
            }
            .bottom-text {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #2947ac;
                margin-left: 10px;
            }
        }
    }
    .notice-title-right {
        cursor: pointer;
        opacity: 0.89;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #2947ac;
        line-height: 24px;
    }
}
.tags {
    margin-bottom: 12px;
    display: flex;
    gap: 16px;
}
.tag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 23%;
    height: 40px;
    background: #2947ac;
    padding: 0 40px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
    white-space: nowrap;
}
.tag-active {
    background: #e8b138;
}
.notice-wrap {
    width: 100%;
    // margin-bottom: 54px;
    padding: 0 15%;
    .notice-wrap1 {
        overflow: hidden;
        padding: 30px 0;
        display: flex;
        gap: 60px;
    }
    .notice {
        // width: 585px;
        flex: 1;
        overflow: hidden;
        .notice-item {
            width: 100%;
            padding: 19px 14px;
            border-bottom: 1px solid #d8d8d8;
            .notice-item-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
            }
            .notice-item-content1 {
                cursor: pointer;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 16px;
                color: #424242;
                white-space: nowrap; /* 确保文本在一行内显示 */
                overflow: hidden; /* 超出容器的文本隐藏 */
                text-overflow: ellipsis; /* 超出部分显示省略号 */
            }
            .notice-item-content2 {
                width: 50px;
                height: 20px;
                float: right;
                margin-top: 3px;
                background-size: 50px 20px;
            }
            .notice-item-date {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #424242;
                letter-spacing: 0;
                text-align: right;
                white-space: nowrap;
            }
        }
        .notice-item:hover {
            background-color: rgba(41, 71, 172, 0.05);

            .notice-item-content1,
            .notice-item-date {
                color: #4554af;
            }
        }
    }
    // @media screen and (max-width: 1500px) {
    //   .notice {
    //     width: 585px;
    //   }
    // }
    // @media screen and (min-width: 1500px) and (max-width: 1800px) {
    //   .notice {
    //     width: 670px;
    //     margin-right: 60px;
    //   }
    // }
    // @media screen and (min-width: 1800px) {
    //   .notice {
    //     width: 785px;
    //     margin-right: 30px;
    //   }
    // }
    // .download {
    //   width: 585px;
    // }
    // @media screen and (max-width: 1500px) {
    //   .download {
    //     width: 585px;
    //   }
    // }
    // @media screen and (min-width: 1500px) and (max-width: 1800px) {
    //   .download {
    //     width: 670px;
    //   }
    // }
    // @media screen and (min-width: 1800px) {
    //   .download {
    //     width: 785px;
    //   }
    // }
    .download {
        flex: 1;
        .download-title {
            height: 33px;
            margin-bottom: 30px;
            margin-top: 20px;
            .download-title-left {
                float: left;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                font-size: 24px;
                color: #222222;
                letter-spacing: 0;
                line-height: 33px;
            }
            .download-title-right {
                cursor: pointer;
                float: right;
                width: 62px;
                height: 26px;
                border: 1px solid #e5e5e5;
                border-radius: 14px;
                margin-top: 6px;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                text-align: center;
                line-height: 24px;
            }
        }
        .download-item {
            height: 30px;
            margin-bottom: 10px;
            border-bottom: 1px solid #d8d8d8;
            .download-content {
                float: left;
                @media screen and (max-width: 1500px) {
                    .download-content1 {
                        width: 500px;
                    }
                }
                @media screen and (min-width: 1500px) and (max-width: 1800px) {
                    .download-content1 {
                        width: 580px;
                    }
                }
                @media screen and (min-width: 1800px) {
                    .download-content1 {
                        width: 700px;
                    }
                }
                .download-content1 {
                    cursor: pointer;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 18px;
                    color: #393939;
                    letter-spacing: 0;
                    text-align: justify;
                    height: 25px;
                    line-height: 25px;
                    margin-bottom: 6px;
                    white-space: nowrap; /* 确保文本在一行内显示 */
                    overflow: hidden; /* 超出容器的文本隐藏 */
                    text-overflow: ellipsis; /* 超出部分显示省略号 */
                    float: left;
                }
                .download-content2 {
                    height: 20px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 14px;
                    color: #0081e9;
                    letter-spacing: 0;
                    line-height: 20px;
                    float: right;
                }
            }
            .download-btn {
                cursor: pointer;
                float: right;
                width: 18px;
                height: 18px;
                margin-right: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/notice.vue